<template>
  <div v-if="route.query?.onlyPlayer === 'true'" class="w-full h-screen">
    <div v-if="media.type?.toLowerCase() === 'audio'">
      <MediaAudio :audio="media" />
    </div>
    <div v-else>
      <MediaVideo :video="media" />
    </div>
  </div>
  <DetailMedia :media="media" v-else />
</template>
<script lang="ts" setup>
import { getMediaBySlug } from '~/queries/media'

const route = useRoute()

const props = defineProps({
  slug: String,
})
let { slug } = useResourceSlug()
if (!slug) {
  slug = props.slug
}
const { data, pending, error } = await useAsyncData(`/media/${slug}/`, () =>
  execQuery(getMediaBySlug, { slug, code: route.query.code })
)
const media = computed<Media>(() => {
  if (pending.value || error.value) return {}
  return data.value.data.medias
})

const title = computed(() => {
  return media.value?.title
})

const description = computed(() => {
  return removeHtml(media.value?.summary)
})

useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
  ],
})

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,
  ogImage: media.value?.thumbnail?.getUrl,
  twitterCard: 'summary',
})
</script>
